import {
  Component,
  ContentChild,
  ContentChildren,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
})
export class ButtonComponent {
  @Input() color = 'primary';
  @Input() text: string;
  @Input() innerClass: string;
  @Input() srcIcon: string;
  @Input() srcIcon2: string;
  @Input() class: string;
  @Input() iconSide = 'left';
  @Input() iconSide2 = 'right';
  @Input() disabled = false;
  @Input() stroked = false;
  @Input() loading = false;
  @Output() handleClick = new EventEmitter();

  public onClick(event: Event) {
    if (!this.disabled) this.handleClick.emit();
    else {
      event.stopPropagation();
    }
  }
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
  }
  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
  }
}
